import { defineComponent as _defineComponent } from 'vue'
import { useContactTimelineFilterStore, useFilterStore } from '@/stores';
import { CallType } from '@/types';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactTimelineFilters',
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = useI18n();

const filterStore = useFilterStore();
const timelineStore = useContactTimelineFilterStore();

const dateRange = computed<Array<Date>>({
    get: () => filterStore.dateRange,
    set: (range) => filterStore.setDateRange(range),
});

const callTypeFilterOptions = [
    { label: t(`call.type.${CallType.INBOUND}`), value: CallType.INBOUND },
    { label: t(`call.type.${CallType.OUTBOUND}`), value: CallType.OUTBOUND },
    { label: t(`call.type.${CallType.INTERNAL}`), value: CallType.INTERNAL },
];

const sentimentFilterOptions = [
    { label: t('contact.filters.sentiment.satisfied'), value: 'positive' },
    { label: t('contact.filters.sentiment.neutral'), value: 'neutral' },
    { label: t('contact.filters.sentiment.unsatisfied'), value: 'negative' },
];

const __returned__ = { t, filterStore, timelineStore, dateRange, callTypeFilterOptions, sentimentFilterOptions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})